import { deleteRequest, get, post} from './_defaults/fetch.js';

export const getAreas = ({params, config}) => get('/areas', {params, ...config});
export const getArea = ({id, params, config}) => get(`/areas/${id}`, {params, ...config});
export const createArea = ({data, config}) => post('/areas', data, config);
export const updateArea = ({id, data, config}) => post(`/areas/${id}`, data, config);
export const deleteArea = ({id, config}) => deleteRequest(`/areas/${id}`, null, config);

